import { Center, CenterProps, Image } from '@chakra-ui/react';
import { SimpleFileLink } from '@texas/api/endpoints/filesApi';
import { clientEndpoints } from '@texas/clientEndpoints';
import { Icons } from '@texas/components/shared/Icons';

interface Props extends CenterProps {
  alt: string;
  file: SimpleFileLink | null;
  size?: string;
}

export function EntityDirectoryFileThumbnail({
  alt,
  file,
  size = '56px',
  ...props
}: Props) {
  return (
    <Center
      bg="entityDirectory.surface"
      border="1px solid"
      borderColor="entityDirectory.border"
      boxSize={size}
      color="entityDirectory.mutedText"
      flexShrink={0}
      {...props}
    >
      {file ? (
        <Image
          alt={alt}
          boxSize="full"
          objectFit="contain"
          src={clientEndpoints.previewImage(file.identifier, 128)}
        />
      ) : (
        <Icons.ImageOutline boxSize={5} />
      )}
    </Center>
  );
}
